/** @jsx jsx */

import React, { Fragment, useState } from 'react';
import { css, jsx } from '@emotion/react';

import Props from '../../UI/list/base/props';
import { RisersAndFallersDataModel } from '../View/risers-fallers-table';
import { Icon } from '@bdl-cmn-shared-packages-npm/design-system';
import RoundTag from '../../RoundTag/roundTag.component';
import { sharedStyle } from '../../../../styles/shared';

export const TopTradedSecurityCard = (props: any): JSX.Element => {
  const { card } = props;
  const { type } = props;

  if (!card) return <></>;

  return (
    <div css={{ width: "100%" }}>
      <div
        css={css`
          background: #ffffff;
          border: 1px solid #d9dee2;
          border-radius: 8px;
          filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.2));
          margin-bottom: 16px;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            border-bottom: solid 1px #d9dee2;
            padding: 16px;
            flex-wrap: wrap;
          `}
        >
          <div
            css={css`
              font-weight: 800;
              font-size: 20px;
              line-height: 26px;
              color: #253845;
              display:flex;
            `}
          >
            <div css={[sharedStyle.cardContainerBodyDoubleLeft, css`padding-right:5px;`]}>
              <RoundTag small textColor={'#425563'}>
                {type}
              </RoundTag>
            </div>
            <div>{card.name}</div>
          </div>
        </div>
        <div
          css={css`
            padding: 16px;
            border-bottom: solid 1px #d9dee2;
          `}
        >
          <div
            css={css`
              font-weight: 700;
              font-size: 14px;
              line-height: 150%;
              letter-spacing: 0.01em;
              color: #425563;
            `}
          >
            ISIN
          </div>
          <div
            css={css`
              font-size: 14px;
              line-height: 18px;
              letter-spacing: 0.01em;
              color: #54666f;
              margin-top: 8px;
            `}
          >
            {card.isinCode}
          </div>
        </div>
        <div
          css={css`
            border-bottom: solid 1px #d9dee2;
            display: flex;
          `}
        >
          <div
            css={css`
              width: 50%;
              border-right: solid 1px #d9dee2;
              padding: 16px;
            `}
          >
            <div
              css={css`
                font-weight: 700;
                font-size: 14px;
                line-height: 150%;
                letter-spacing: 0.01em;
                color: #425563;
              `}
            >
              Currency
            </div>
            <div
              css={css`
                font-size: 14px;
                line-height: 18px;
                letter-spacing: 0.01em;
                color: #54666f;
                margin-top: 8px;
              `}
            >
              <div>{card.currency}</div>
            </div>
          </div>
          <div
            css={css`
              width: 50%;
              padding: 16px;
            `}
          >
            <div
              css={css`
                font-weight: 700;
                font-size: 14px;
                line-height: 150%;
                letter-spacing: 0.01em;
                color: #425563;
              `}
            >
              Turnover
            </div>
            <div
              css={css`
                font-size: 14px;
                line-height: 18px;
                letter-spacing: 0.01em;
                color: #54666f;
                margin-top: 8px;
              `}
            >
              {card.turnover}
            </div>
          </div>
        </div>
        <div
          css={css`
            padding: 16px;
            border-bottom: solid 1px #d9dee2;
          `}
        >
          <div
            css={css`
              font-weight: 700;
              font-size: 14px;
              line-height: 150%;
              letter-spacing: 0.01em;
              color: #425563;
            `}
          >
            Trades
          </div>
          <div
            css={css`
              font-size: 14px;
              line-height: 18px;
              letter-spacing: 0.01em;
              color: #54666f;
              margin-top: 8px;
            `}
          >
            {card.numberOfTransaction}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopTradedSecurityCard;
